export enum GoalProgressDateRangePreset {
  Goal = 'goal',
  Week = 'week',
  Month = 'month',
  Quarter = 'quarter',
  Year = 'year',
}
